import {
	PAGE_AFTER_LOGIN_KEY,
	QUERY_PARAMS_AFTER_LOGIN_KEY,
} from '../hooks/useSessionStoredUrl';

const isSafePathname = (pathname: string): boolean =>
	pathname.startsWith('/') && !pathname.startsWith('//');

export const rememberCurrentLocation = (): void => {
	const { pathname, search } = window.location;

	if (pathname && pathname !== '/' && isSafePathname(pathname)) {
		sessionStorage.setItem(PAGE_AFTER_LOGIN_KEY, pathname);
	}
	if (search) {
		sessionStorage.setItem(QUERY_PARAMS_AFTER_LOGIN_KEY, search);
	}
};
